import { css } from 'styled-components';
export const BKJThemeTypography = {
    H1: css `
    ${({ theme }) => theme.fonts.PoppinsBold}
    font-size: 70px;
    line-height: 84px;
  `,
    H2: css `
    ${({ theme }) => theme.fonts.PoppinsMedium}
    font-size: 45px;
    line-height: 55px;
  `,
    H3: css `
    ${({ theme }) => theme.fonts.PoppinsBold}
    font-size: 28px;
    line-height: 34px;
  `,
    H4: css `
    ${({ theme }) => theme.fonts.PoppinsBold}
    font-size: 20px;
    line-height: 28px;
  `,
    Body: css `
    ${({ theme }) => theme.fonts.PoppinsTextMedium}
    font-size: 16px;
    line-height: 24px;
  `,
    BodyUnderline: css `
    ${({ theme }) => theme.fonts.PoppinsTextMedium}
    font-size: 16px;
    line-height: 24px;
  `,
    Bold: css `
    ${({ theme }) => theme.fonts.PoppinsTextBold}
    font-size: 16px;
    line-height: 24px;
  `,
    Caption: css `
    ${({ theme }) => theme.fonts.PoppinsTextMedium}
    font-size: 14px;
    line-height: 21px;
  `,
    CaptionBold: css `
    ${({ theme }) => theme.fonts.PoppinsTextBold}
    font-size: 14px;
    line-height: 21px;
  `,
    Button: css `
    ${({ theme }) => theme.fonts.PoppinsTextBold}
    font-size: 16px;
    line-height: 24px;
  `,
    TextLink: css `
    ${({ theme }) => theme.fonts.PoppinsTextBold}
    font-size: 16px;
    line-height: 24px;
  `,
};
//# sourceMappingURL=BKJTypography.theme.js.map